/**
 * @file: valueAfterAutoFill.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

/**
 * Decide what a field auto-filled from a lookup should hold once a fresh
 * lookup result arrives. The lookup owns the field until the staff type over
 * it: a new result takes an empty field or one that still holds the previous
 * result, and leaves anything the staff entered untouched.
 */
export function valueAfterAutoFill<T>(
  current: T,
  next: T,
  lastAutoFilled: T | undefined,
): T {
  const isEmpty =
    current == null || (typeof current === 'string' && !current.trim());
  return isEmpty || current === lastAutoFilled ? next : current;
}
